import { render, staticRenderFns } from "./SubscriptionAssignDialog.vue?vue&type=template&id=6076f664&lang=pug&"
import script from "./SubscriptionAssignDialog.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionAssignDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionAssignDialog.vue?vue&type=style&index=0&id=6076f664&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports